import { gql } from '@apollo/client';

export default class EmployeeQuery {
    static GET_EMPLOYEE_LIST = gql`
        query getEmployeeList(
            $filter: EmployeeListFilter
            $paginate: PaginationInput
            $sort: DataSort
        ) {
            getEmployeeList(filter: $filter, paginate: $paginate, sort: $sort) {
                totalCount
                data {
                    userId
                    fullName
                    userName
                    employeeType
                    department
                    usersLot
                    hireDate
                    terminateDate
                    status
                    active
                    nonemployee
                    email
                    workEmail
                    cellPhone
                }
            }
        }
    `;

    static GET_EMPLOYEE_LOGIN_PERMISSION = gql`
        query getEmployeeLoginPermission($userId: Int!) {
            getEmployeeLoginPermission(userId: $userId) {
                user {
                    userId
                    userName
                    password
                    isSupervisor
                    mustRenewPassword
                    bhphDashboard
                    defaultLot
                    userPicture
                }
                permissions
                availableLots {
                    lotId
                    lotName
                }
                hiddenLots {
                    lotId
                    lotName
                }
            }
        }
    `;
}
